{
  "RequestAvailabilityDialog": {
    "title": "Request availability",
    "viaEmail": "Via Email",
    "viaLink": "Via Link",
    "requestedDates": "Requested dates",
    "requestedDatesHelper": "Resources will be guided to fill in availability between these dates",
    "addMessage": "Add message",
    "addMessageHelper": "Write a message that will be attached within the email",
    "messagePlaceholder": "Start writing...",
    "next": "Next",
    "generateLink": "Generate Link",
    "generatedUrl": "Generated URL",
    "urlExpiresOn": "This URL will expire on the {{date}}",
    "done": "Done",
    "copyUrl": "Copy URL",
    "copied": "Copied",
    "back": "Back",
    "recipients": "Recipients",
    "recipientsHelper": "Confirm who should receive the availability request email",
    "searchPlaceholder": "Search and add resources",
    "noSearchResults": "No resources found",
    "noRecipients": "Add at least one recipient",
    "missingEmailsMessage": "No email found for these resources. Please add one below.",
    "recipientsCount": "{{count}} Recipient",
    "recipientsCount_other": "{{count}} Recipients",
    "removeRecipient": "Remove recipient",
    "email": "Email",
    "noEmail": "No email",
    "addEmail": "Add email",
    "saveEmail": "Save email",
    "resourceEmail": "Resource email",
    "emailPlaceholder": "Enter email",
    "confirmAndSend": "Confirm & Send",
    "emailPreviewTitle": "Email preview",
    "emailPreviewHelper": "Confirm the request we'll be sending out",
    "emailPreviewGreeting": "Hi {{name}},",
    "emailPreviewBody": "{{sender}} at {{company}} wants to know when you are next available.",
    "emailPreviewDatesLabel": "Dates requested",
    "emailPreviewDateRange": "From <start>{{startDate}}</start> to <end>{{endDate}}</end>",
    "emailPreviewCtaHint": "Click on the link below to share your availability.",
    "emailPreviewShareButton": "Share Availability",
    "emailPreviewExpiry": "This URL will be active for 28 days before expiring. If it expires please contact the requester for a new link.",
    "sending": "Sending…",
    "sendSuccessTitle": "{{count}} request sent",
    "sendSuccessTitle_other": "{{count}} requests sent",
    "unsavedChangesBeforeUnload": "You have unsaved changes in the availability request form!",
    "dateRangeRequired": "Please select a date range",
    "resourceRequired": "Please select a resource",
    "emailRequired": "Each recipient needs an email address"
  }
}
